export const pointRules = {
  title: "월드컵 티비 포인트 적립 제도 안내",
  notices: [
    "적립된 포인트는 월드컵 TV 텔레그램 문의시 보증업체로 포인트전환이 가능합니다.",
    "포인트 획득을 위한 도배 및 어뷰징 등의 행위자는 통보없이 \"포인트몰수\" 또는 \"계정차단\" 등의 조치를 받을 수 있습니다.",
  ],
};

export interface PointTableItem {
  action: string;
  points: string;
  note: string;
}

export interface PointTableSection {
  title: string;
  items: PointTableItem[];
}

export const pointTableSections: PointTableSection[] = [
  {
    title: "커뮤니티 게시판 포인트 획득 안내",
    items: [
      { action: "회원가입", points: "10000 P", note: "" },
      { action: "로그인시", points: "300 P", note: "자동출석" },
      { action: "지인추천", points: "1000 P", note: "" },
    ],
  },
  {
    title: "보증업체 게시판",
    items: [
      { action: "제휴보증업체 읽기", points: "X", note: "" },
      { action: "제휴보증업체 댓글", points: "50 P", note: "1일10회" },
    ],
  },
  {
    title: "월드컵픽스터 게시판",
    items: [
      { action: "게시글 작성", points: "100 P", note: "1일 5회" },
      { action: "게시글 댓글", points: "50 P", note: "1일 10회" },
    ],
  },
  {
    title: "커뮤니티 게시판",
    items: [
      { action: "자유게시판 게시글 작성", points: "100 P", note: "1일 5회" },
      { action: "자유게시판 게시글 댓글", points: "50 P", note: "1일 10회" },
    ],
  },
  {
    title: "홍보센터 게시판",
    items: [
      { action: "일반홍보 게시글 작성", points: "-1000 P", note: "1일 5회" },
      { action: "일반홍보 게시글 댓글", points: "50 P", note: "1일 10회" },
    ],
  },
];

export const levelExperienceData: { level: number; exp: string }[] = [
  { level: 1, exp: "0" },
  { level: 2, exp: "1,000" },
  { level: 3, exp: "2,100" },
  { level: 4, exp: "3,300" },
  { level: 5, exp: "4,600" },
  { level: 6, exp: "6,000" },
  { level: 7, exp: "7,500" },
  { level: 8, exp: "9,100" },
  { level: 9, exp: "10,800" },
  { level: 10, exp: "12,600" },
  { level: 11, exp: "14,500" },
  { level: 12, exp: "16,500" },
  { level: 13, exp: "18,600" },
  { level: 14, exp: "20,800" },
  { level: 15, exp: "23,100" },
  { level: 16, exp: "25,500" },
  { level: 17, exp: "28,000" },
  { level: 18, exp: "30,600" },
  { level: 19, exp: "33,300" },
  { level: 20, exp: "36,100" },
  { level: 21, exp: "39,000" },
  { level: 22, exp: "42,000" },
  { level: 23, exp: "45,100" },
  { level: 24, exp: "48,300" },
  { level: 25, exp: "51,600" },
  { level: 26, exp: "55,000" },
  { level: 27, exp: "58,500" },
  { level: 28, exp: "62,100" },
  { level: 29, exp: "65,800" },
  { level: 30, exp: "69,600" },
  { level: 31, exp: "73,500" },
  { level: 32, exp: "77,500" },
  { level: 33, exp: "81,600" },
  { level: 34, exp: "85,800" },
  { level: 35, exp: "90,100" },
  { level: 36, exp: "94,500" },
  { level: 37, exp: "99,000" },
  { level: 38, exp: "103,600" },
  { level: 39, exp: "108,300" },
  { level: 40, exp: "113,100" },
  { level: 41, exp: "118,000" },
  { level: 42, exp: "123,000" },
  { level: 43, exp: "128,100" },
  { level: 44, exp: "133,300" },
  { level: 45, exp: "138,600" },
  { level: 46, exp: "144,000" },
  { level: 47, exp: "149,500" },
  { level: 48, exp: "155,100" },
  { level: 49, exp: "160,800" },
  { level: 50, exp: "166,600" },
  { level: 51, exp: "172,500" },
  { level: 52, exp: "178,500" },
  { level: 53, exp: "184,600" },
  { level: 54, exp: "190,800" },
  { level: 55, exp: "197,100" },
  { level: 56, exp: "203,500" },
  { level: 57, exp: "210,000" },
  { level: 58, exp: "216,600" },
  { level: 59, exp: "223,300" },
  { level: 60, exp: "230,100" },
  { level: 61, exp: "237,000" },
  { level: 62, exp: "244,000" },
  { level: 63, exp: "251,100" },
  { level: 64, exp: "258,300" },
  { level: 65, exp: "265,600" },
  { level: 66, exp: "273,000" },
  { level: 67, exp: "280,500" },
  { level: 68, exp: "288,100" },
  { level: 69, exp: "295,800" },
  { level: 70, exp: "303,600" },
  { level: 71, exp: "311,500" },
  { level: 72, exp: "319,500" },
  { level: 73, exp: "327,600" },
  { level: 74, exp: "335,800" },
  { level: 75, exp: "344,100" },
  { level: 76, exp: "352,500" },
  { level: 77, exp: "361,000" },
  { level: 78, exp: "369,600" },
  { level: 79, exp: "378,300" },
  { level: 80, exp: "387,100" },
  { level: 81, exp: "396,000" },
  { level: 82, exp: "405,000" },
  { level: 83, exp: "414,100" },
  { level: 84, exp: "423,300" },
  { level: 85, exp: "432,600" },
  { level: 86, exp: "442,000" },
  { level: 87, exp: "451,500" },
  { level: 88, exp: "461,100" },
  { level: 89, exp: "470,800" },
  { level: 90, exp: "480,600" },
  { level: 91, exp: "490,500" },
  { level: 92, exp: "500,500" },
  { level: 93, exp: "510,600" },
  { level: 94, exp: "520,800" },
  { level: 95, exp: "531,100" },
  { level: 96, exp: "541,500" },
];